// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.showRightPanel[data-v-1e488bfb] {\r\n  overflow: hidden;\r\n  position: relative;\r\n  width: calc(100% - 15px);\n}\r\n", ""]);
// Exports
module.exports = exports;
